module.exports = __webpack_public_path__ + "static/media/download.e2a957ae.svg";